import { Component, Inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Envion35Service } from 'app/main/wizard-n35encuestador/services/envion35.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { PdfMakeWrapper, Txt, Ul, Item, Columns } from 'pdfmake-wrapper';
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfFontsHK from "pdfmake/build/vfs_fonts0";
// import { pdfFonts} from 'pdfmake-wrapper/custom-fonst';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
// import pdfFonts from 'src/assets/custom-fonst';
// declare var require: any;
// var myUser= require('../assets/custom-fonst.js');
// const pdfFonts = require('../assets/custom-fonst') as any;

@Component({
  selector: 'app-descarga-encuesta',
  templateUrl: './descarga-encuesta.component.html',
  styleUrls: ['./descarga-encuesta.component.scss']
})
export class DescargaEncuestaComponent {

  langs: any[] = [
    {id: 1, nombre: 'Inglés'},
    {id: 2, nombre: 'Español'},
    {id: 3, nombre: 'Chino'},
    {id: 4, nombre: 'Turco'}
  ];

  informacion:any;
  productosVer3:boolean;
  claveidiomaAnterior:any;

  constructor(
    private translateSrv: TranslateService,
    private idiomasService: IdiomasService,
    private odsService: ODSService,
    public dialogRef: MatDialogRef<DescargaEncuestaComponent>,
    private envioService: Envion35Service,
    private wizardService: WizardService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.informacion=data;
    console.log('data informacion', data);
    console.log("pdfFonts:",pdfFonts);

    console.log(this.informacion);
    if (this.informacion.productoId==40 || this.informacion.productoId==41 ||this.informacion.productoId==42 || this.informacion.productoId==43 || this.informacion.productoId==75) {
      this.productosVer3=true,
      this.getSeccionesGuardadasProducto();
      this.getListaIdiomas(this.informacion.plantilla,this.informacion.fecha, this.informacion.idEmpresa,this.informacion.idProducto);
    }else{
      console.log('entro el caso de que el producto no es version 3.0');
      this.productosVer3=false,
      this.getListaIdiomas(this.informacion.plantilla,this.informacion.fecha, this.informacion.idEmpresa,this.informacion.idProducto);
      switch (this.informacion.productoId) {
        case 3: case 63:
          break;
        default:
          this.getSeccionesGuardadasProducto();
          break;
      }

    }
    this.claveidiomaAnterior=this.translateSrv.currentLang;
  }
  //booleans secciones removibles
  hasNps = true;
  hasReact = true;
  hasDemog = true;
  hasControl = true;
  hasForall = true;
  hasOpen = true;
  hasAdici = true;
  idiomas:any;
  langNat: any[] = [];
  lang1Ok = false;
  lang2Ok = false;

  getSeccionesGuardadasProducto(){
    let datos = {productoId: this.informacion.idProducto};
    this.wizardService.getSeccionesCertificarDescargaEncuesta(this.informacion.idEmpresa,datos).subscribe((data:any) => {
      console.log(data);
      if(data.success){
        data.secciones.forEach( (seccion) => {
          console.log('seccion',seccion);
          switch(seccion.nombre){
            case 'Forall':
            this.hasForall = seccion.estatus;
            break;
            case 'Demograficos':
            this.hasDemog = seccion.estatus;
            break;
            case 'Adicionales':
            this.hasAdici = seccion.estatus;
            break;
            case 'Reactivos':
            this.hasReact = seccion.estatus;
            break;
            case 'Abiertas':
            this.hasOpen = seccion.estatus;
            break;
            case 'Control':
            this.hasControl = seccion.estatus;
            break;
            case 'NPS':
            this.hasNps = seccion.estatus;
            break;
          }
        });
      }
    });
  }
  obtenerIdiomas(){
    let fechaProducto: backInter.getIdiomaFechas = {productoId:this.informacion.idProducto};
    this.idiomasService.getIdiomasCertificar(fechaProducto,this.informacion.idEmpresa).subscribe( (data: backInter.getIdiomas) => {
      console.log(data);
      this.idiomas = data.idiomasMostrar;
    });
  }
  cargaTotal:boolean=false;
  hasNorma:boolean=false;
  mas50:boolean=false;
  menos50:boolean=false;
  selectNorma:any[]=[];
  getListaIdiomas(idPlantilla:string, fechaCertificar:number, idEmpresa, productoId){
    //Obtiene la lista de idiomas del backend
    console.log(this.informacion.tipoProducto);

    switch(this.informacion.tipoProducto){
      case 1: case "1": case 40: case 41: case 42: case 43: case 75://Certificar
      let productoIdCer: backInter.getIdiomaFechas = {productoId:productoId};
      this.idiomasService.getIdiomasProd_Detail(productoIdCer,idEmpresa).subscribe( (data: backInter.getIdiomas) => {
        console.log(data);
        this.colocaIdioma(data);

      });
      break;
      case 2: case "2": //Medir
      let fechaProductoMedir: backInter.getIdiomaFechas = {productoId:productoId};
      this.idiomasService.getIdiomasProdMedir_Detail(fechaProductoMedir,idEmpresa).subscribe( (data: backInter.getIdiomas) => {
        console.log(data);
        this.langs = [];
        this.colocaIdioma(data);;
      });
      break;
      case 11: case 12: case 13: case 14: case 15: case 16:
      let datosMedir_Generico:any = {productoId};
      this.idiomasService.getIdiomasProdMedir_Detail(datosMedir_Generico,idEmpresa).subscribe( (data: backInter.listaIdiomasBack) => {
        console.log(data);
        this.langs = [];
        console.log(data.idiomas);
        this.colocaIdioma(data);
      });
      break;
      case 4: case "4":
      console.log("Datos pulse");
      let datosPulse:any = {productoId:productoId};
      this.idiomasService.getIdiomasProdPulse_Detail(datosPulse,idEmpresa).subscribe( (data: backInter.listaIdiomasBack) => {
        this.langs = [];
        console.log(data);
        this.colocaIdioma(data);
      });
      break;
      case 5: case "5": case undefined: case 3: case 63:
        console.log("Debe ser norma");
        this.hasNorma=true;
        let dataEnc={
          productoId: productoId
        };
        this.envioService.obtenerPilito_Detail(dataEnc,idEmpresa).subscribe((response:backInter.getPilotoN35) => {
          console.log(response);
          if(response.success){
            //this.selectNorma=this.nom35;
            this.selectNorma=[];
            if(response.urlMas50.length > 1 && response.urlMenos50.length>1){
              this.selectNorma = [
                {
                  id: "1",
                  nombre: "DESCARGAR_ENCUESTA.MODAL.MENOS50",
                },{
                  id: "2",
                  nombre: "DESCARGAR_ENCUESTA.MODAL.MAS50",
                }
              ];
            }else if(response.urlMas50.length > 1){
              this.selectNorma = [
                {
                  id: "2",
                  nombre: "DESCARGAR_ENCUESTA.MODAL.MAS50",
                }
              ];
            }else if(response.urlMenos50.length>1){
              this.selectNorma = [
                {
                  id: "1",
                  nombre: "DESCARGAR_ENCUESTA.MODAL.MENOS50",
                }
              ];
            }
            this.cargaTotal=true;

          }
        }, error => {
          console.log(error);
        });
      break;
    }

  }
  colocaIdioma(data){

    this.langs = [];
    let iter = 0;
    data.idiomasMostrar.forEach( (elemento) => {
      if(elemento.tipoIdioma != "3"){
        this.translateSrv.get('NOMBREIDIOMAS.'+elemento.nombreIdioma).subscribe((res: string) => {
          let idiomaRecuperado: any = {id:iter, nombre: res, clave:elemento};
          this.langs.push(idiomaRecuperado);
        });
        iter++;
      }
    });
    console.log(this.langs);
    this.cargaTotal=true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  idIdioma:any;
  idIdiomaClave:any;
  transLang:any;
  idNom035:any;
  btnLocked:boolean=true;

  selLangId(lang: any){
    this.idIdioma=lang.clave._id;
    this.transLang=lang.clave.nombreIdioma;
    this.idIdiomaClave=lang.clave.nombreIdioma;

    console.log(lang);

    this.btnLocked=false;
  }
  tipoencuesta:any;
  selectNom35(nom:any){
    this.idNom035=nom.id;
    this.btnLocked=false;
  }

  downLoad(){
    this.modalCarga();
  }
  downLoad35(){
    this.generateNormaPDF(this.idNom035);
  }

  excelDialog(){
    let mensaje: string;
    this.translateSrv.get('PERFILES.EMPRESA.PDF.MODAL').subscribe((res: string) => { mensaje = res; });
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      imageUrl: localStorage.getItem('urlGifBroker'),
      imageWidth: 100,
      imageHeight: 60,
    });
  }

  modalCarga(){
    console.log('this.productosVer3',this.productosVer3);

    this.excelDialog();

    this.translateSrv.use(this.transLang);

    let nps = this.translateSrv.instant('DESCARGAR_ENCUESTA.NPS');
    let reactivos = this.translateSrv.instant('DESCARGAR_ENCUESTA.REACTIVOS');
    let control = this.translateSrv.instant('DESCARGAR_ENCUESTA.CONTROL');
    let demograficos = this.translateSrv.instant('DESCARGAR_ENCUESTA.DEMOGRAFICOS');
    let abiertas = this.translateSrv.instant('DESCARGAR_ENCUESTA.ABIERTAS');
    let ca = this.translateSrv.instant('DESCARGAR_ENCUESTA.CA');
    let codigoProyecto = this.translateSrv.instant('DESCARGAR_ENCUESTA.CODIGOPROYECTO');
    let anioAplicacion = this.translateSrv.instant('DESCARGAR_ENCUESTA.ANIOAPLICACION');
    let mensaje = this.translateSrv.instant('DESCARGAR_ENCUESTA.MENSAJE');
    let aceptar = this.translateSrv.instant('DESCARGAR_ENCUESTA.ACEPTAR');
    let textoDescarga = this.translateSrv.instant('DESCARGAR_ENCUESTA.TEXTODESCARGA');
    let informacionAviso = this.translateSrv.instant('DESCARGAR_ENCUESTA.INFORMACIONYAVISO');

    let numeracion:number=1;
    let numeracionForall:number=0;
    let informacionEncuesta:string;
    let htmlToPdfmake = require("html-to-pdfmake");
    if (!this.productosVer3) {
      this.odsService.getEncuestaBylang(this.informacion.idEmpresa,this.informacion.idProducto,this.idIdioma).subscribe((respuesta:any) => {
        console.log("respuesta",respuesta);

        if(respuesta.success==true){

          const pdf = new PdfMakeWrapper();
           if(this.informacion.instituto == 3){  //si el instituto es 3 (HK) se colocan los caracteres chinos
            PdfMakeWrapper.setFonts(pdfFontsHK);
          }else{
            PdfMakeWrapper.setFonts(pdfFonts);
          }
          pdf.add(
            new Columns([
              new Txt(this.informacion.nombreEmpresa).bold().fontSize(30).end,
              new Txt(codigoProyecto+this.informacion.codigoDeProyecto+"\n"+
              anioAplicacion+this.informacion.fecha).bold().fontSize(12).alignment('right').end
            ]).end
          );

          //INFORMACION ENCUESTA
          pdf.add(pdf.ln(1));
          pdf.add(new Txt(informacionAviso).bold().fontSize(20).alignment('left').end);

          pdf.add(pdf.ln(1));

          informacionEncuesta=respuesta.instrucciones.replace(/replace2/g,this.informacion.nombreEmpresa);
          informacionEncuesta=htmlToPdfmake(informacionEncuesta);

          pdf.add(new Txt(informacionEncuesta).fontSize(12).alignment('left').end);
          pdf.add(pdf.ln(1));

          //NPS
              if (this.hasNps) {
              if(respuesta.nps){
                if(respuesta.nps.length>0){
                  pdf.add(pdf.ln(1));
                  pdf.add(new Txt(nps).fontSize(18).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  respuesta.nps.forEach(element => {
                    pdf.add(new Txt(numeracion+". "+element.pregunta).fontSize(12).alignment('left').end);
                    pdf.add(pdf.ln(1));
                    numeracion=numeracion+1;
                  });
                  numeracion=1;
                }
              }

            }

            // Reactivos
            if (this.hasReact) {
              if(respuesta.reactivos){
                if(respuesta.reactivos.length>0){
                  pdf.add(pdf.ln(1));
                  pdf.add(new Txt(reactivos).fontSize(18).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  pdf.add(new Txt(respuesta.perspectivaOrg).fontSize(14).alignment('left').end);
                  respuesta.reactivos.forEach(element1 => {
                    pdf.add(new Txt(element1.pregunta).fontSize(12).alignment('left').end);
                    pdf.add(pdf.ln(1));
                    element1.respuestas.forEach(resp1 => {
                      pdf.add(
                        new Ul([
                          new Item(
                            new Txt(resp1.respuesta).fontSize(12).end
                          ).listType('circle').end
                        ]).end
                      )
                    });
                    pdf.add(pdf.ln(1));
                  });

                  pdf.add(pdf.ln(1));
                  pdf.add(new Txt(respuesta.perspectivaGrup).fontSize(14).alignment('left').end);
                  respuesta.reactivos.forEach(element => {
                    pdf.add(new Txt(element.pregunta).fontSize(12).alignment('left').end);
                    pdf.add(pdf.ln(1));
                    element.respuestas.forEach(resp => {
                      pdf.add(
                        new Ul([
                          new Item(
                            new Txt(resp.respuesta).fontSize(12).end
                          ).listType('circle').end
                        ]).end
                      )
                    });
                    pdf.add(pdf.ln(1));
                  });

                }
              }
            }
            //CONTROL
          console.log('this.informacion.tipoProducto',this.informacion.tipoProducto);

            if (this.informacion.tipoProducto==2 || this.informacion.tipoProducto==3) {
              console.log('Es un medir & no debe de hacer nada ');
              console.log('this.informacion.tipoProducto',this.informacion.tipoProducto);


            }else{
              console.log('this.informacion.tipoProducto',this.informacion.tipoProducto);

              if (this.hasControl) {
                if(respuesta.control){
                  if(respuesta.control.length>0){
                    pdf.add(pdf.ln(1));
                    pdf.add(new Txt(control).fontSize(18).alignment('left').end);
                    pdf.add(pdf.ln(1));

                    respuesta.control.forEach(element => {
                      pdf.add(new Txt(numeracion+". "+element.pregunta).fontSize(12).alignment('left').end);
                      pdf.add(pdf.ln(1));
                      element.respuestas.forEach(res => {
                        pdf.add(
                          new Ul([
                            new Item(
                              new Txt(res.respuesta).fontSize(12).end
                            ).listType('circle').end
                          ]).end
                        )
                      });
                      pdf.add(pdf.ln(1));
                      numeracion=numeracion+1;
                    });
                    numeracion=1;
                  }
                }
              }

            }
            //DEMOGRAFICOS
            if (this.hasDemog) {
              if(respuesta.demograficos){
                if(respuesta.demograficos.length>0){
                  pdf.add(pdf.ln(1));
                  pdf.add(new Txt(demograficos).fontSize(18).alignment('left').end);
                  pdf.add(pdf.ln(1));

                  respuesta.demograficos.forEach(element => {
                    pdf.add(new Txt(numeracion+". "+element.pregunta).fontSize(12).alignment('left').end);
                    pdf.add(pdf.ln(1));
                    element.respuestas.forEach(res => {
                      pdf.add(
                        new Ul([
                          new Item(
                            new Txt(res.respuesta).fontSize(12).end
                          ).listType('circle').end
                        ]).end
                      )
                    });
                    pdf.add(pdf.ln(1));
                    numeracion=numeracion+1;
                  });
                  numeracion=1;
                }
              }
            }
            // Abiertas
            if (this.hasOpen) {
              if(respuesta.abiertas){
                if(respuesta.abiertas.length>0){ //Abiertas
                  pdf.add(pdf.ln(1));
                  pdf.add(new Txt(abiertas).fontSize(18).alignment('left').end);
                  pdf.add(pdf.ln(1));

                  respuesta.abiertas.forEach(element => {
                    pdf.add(new Txt(numeracion+". "+element.pregunta).fontSize(12).alignment('left').end);
                    pdf.add(pdf.ln(1));
                    numeracion=numeracion+1;
                  });
                  numeracion=1;
                }
              }
            }
            //Forall
            if (this.hasForall) {
              if(respuesta.forall){
                if(respuesta.forall.length>0){
                  pdf.add(pdf.ln(1));
                  pdf.add(new Txt(ca).fontSize(18).alignment('left').end);
                  pdf.add(pdf.ln(1));

                  respuesta.forall.forEach(element => {
                    pdf.add(new Txt(numeracion+". "+element.pregunta1).fontSize(12).alignment('left').end);
                    pdf.add(pdf.ln(1));
                    element.respuestas1.opciones.forEach( opc =>{
                      pdf.add(
                        new Ul([
                          new Item(
                            new Txt(opc.respuesta).fontSize(12).end
                          ).listType('circle').end
                        ]).end
                      )
                    });
                    pdf.add(pdf.ln(1));

                    pdf.add(new Txt(numeracion+". "+element.pregunta2).fontSize(12).alignment('left').end);
                    pdf.add(pdf.ln(1));
                    element.respuestas2.opciones.forEach( opc =>{
                      pdf.add(
                        new Ul([
                          new Item(
                            new Txt(opc.respuesta).fontSize(12).end
                          ).listType('circle').end
                        ]).end
                      )
                    });
                    pdf.add(pdf.ln(1));
                    numeracion=numeracion+1;
                  });
                  numeracion=1;
                }
              }

            }
          pdf.create().download(textoDescarga+this.informacion.nombreEmpresa+".pdf");
          Swal.close();
          this.translateSrv.use(this.claveidiomaAnterior);
        }
      });
    }else{
      this.odsService.getEncuestaProductosv3a(this.informacion.idProducto,this.idIdiomaClave,this.informacion.instituto).subscribe((respuesta:any) => {
        console.log("respuesta",respuesta);
        if(respuesta.succes==true){
          const pdf = new PdfMakeWrapper();
          if(this.informacion.instituto == 3){  //si el instituto es 3 (HK) se colocan los caracteres chinos
           PdfMakeWrapper.setFonts(pdfFontsHK);
         }else{
           PdfMakeWrapper.setFonts(pdfFonts);
         }
          pdf.add(
            new Columns([
              new Txt(this.informacion.nombreEmpresa).bold().fontSize(30).end,
              new Txt(codigoProyecto+this.informacion.codigoDeProyecto+"\n"+
              anioAplicacion+this.informacion.fecha).bold().fontSize(12).alignment('right').end
            ]).end
          );

          //INFORMACION ENCUESTA
          pdf.add(pdf.ln(1));
          pdf.add(new Txt(informacionAviso).bold().fontSize(20).alignment('left').end);

          pdf.add(pdf.ln(1));

          informacionEncuesta=respuesta.instrucciones.replace(/replace2/g,this.informacion.nombreEmpresa);
          informacionEncuesta=htmlToPdfmake(informacionEncuesta);

          pdf.add(new Txt(informacionEncuesta).fontSize(12).alignment('left').end);
          pdf.add(pdf.ln(1));

          if (this.hasNps) {
            if(respuesta.nps){
              if(respuesta.nps.length>0){
                pdf.add(pdf.ln(1));
                pdf.add(new Txt(nps).fontSize(18).alignment('left').end);
                pdf.add(pdf.ln(1));

                respuesta.nps.forEach(element => {
                  pdf.add(new Txt(numeracion+". "+element.question).fontSize(12).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  element.answers.forEach(res => {
                    pdf.add(
                      new Ul([
                        new Item(
                          new Txt(res.answer).fontSize(12).end
                        ).listType('circle').end
                      ]).end
                    )
                  });
                  pdf.add(pdf.ln(1));
                  numeracion=numeracion+1;
                });
                numeracion=1;
              }
            }

          }

          // Reactivos
          if (this.hasReact) {
            if(respuesta.statements){
              if(respuesta.statements.length>0){
                pdf.add(pdf.ln(1));
                pdf.add(new Txt(reactivos).fontSize(18).alignment('left').end);
                pdf.add(pdf.ln(1));


                pdf.add(new Txt(respuesta.perspectivaOrg).fontSize(14).alignment('left').end);
                respuesta.statements.forEach(element1 => {
                  pdf.add(new Txt(element1.question).fontSize(12).alignment('left').end);
                  pdf.add(
                    pdf.ln(1)
                  );
                  element1.answers.forEach(resp1 => {
                    pdf.add(
                      new Ul([
                        new Item(
                          new Txt(resp1.answer).fontSize(12).end
                        ).listType('circle').end
                      ]).end
                    )
                  });

                  pdf.add(pdf.ln(1));
                });

                pdf.add(pdf.ln(1));
                pdf.add(new Txt(respuesta.perspectivaGrup).fontSize(14).alignment('left').end);
                respuesta.statements.forEach(element => {
                  pdf.add(new Txt(element.question).fontSize(12).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  element.answers.forEach(resp => {
                    pdf.add(
                      new Ul([
                        new Item(
                          new Txt(resp.answer).fontSize(12).end
                        ).listType('circle').end
                      ]).end
                    )
                  });

                  pdf.add(pdf.ln(1));
                });

              }
            }
          }

          //CONTROL
          if (this.hasControl) {
            if(respuesta.control){
              if(respuesta.control.length>0){
                pdf.add(pdf.ln(1));
                pdf.add(new Txt(control).fontSize(18).alignment('left').end);
                pdf.add(pdf.ln(1));

                respuesta.control.forEach(element => {
                  pdf.add(new Txt(numeracion+". "+element.question).fontSize(12).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  element.answers.forEach(res => {
                    pdf.add(
                      new Ul([
                        new Item(
                          new Txt(res.answer).fontSize(12).end
                        ).listType('circle').end
                      ]).end
                    )
                  });
                  pdf.add(pdf.ln(1));
                  numeracion=numeracion+1;
                });
                numeracion=1;
              }
            }
          }

          //DEMOGRAFICOS
          if (this.hasDemog) {
            if(respuesta.demographics){
              if(respuesta.demographics.length>0){
                pdf.add(pdf.ln(1));
                pdf.add(new Txt(demograficos).fontSize(18).alignment('left').end);
                pdf.add(pdf.ln(1));

                respuesta.demographics.forEach(element => {
                  pdf.add(new Txt(numeracion+". "+element.question).fontSize(12).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  element.answers.forEach(res => {
                    pdf.add(
                      new Ul([
                        new Item(
                          new Txt(res.answer).fontSize(12).end
                        ).listType('circle').end
                      ]).end
                    )
                  });
                  pdf.add(pdf.ln(1));
                  numeracion=numeracion+1;
                });
                numeracion=1;
              }
            }

          }

          // Abiertas
          if (this.hasOpen) {
            if(respuesta.open){
              if(respuesta.open.length>0){ //Abiertas
                pdf.add(pdf.ln(1));
                pdf.add(new Txt(abiertas).fontSize(18).alignment('left').end);
                pdf.add(pdf.ln(1));

                respuesta.open.forEach(element => {
                  pdf.add(new Txt(numeracion+". "+element.question).fontSize(12).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  numeracion=numeracion+1;
                });
                numeracion=1;
              }
            }

          }

          //Forall
          if (this.hasForall) {
            if(respuesta.forAll){
              if(respuesta.forAll.length>0){
                pdf.add(pdf.ln(1));
                pdf.add(new Txt(ca).fontSize(18).alignment('left').end);
                pdf.add(pdf.ln(1));

                respuesta.forAll.forEach((element,i) => {
                  if (i%2==0) {
                    console.log('numeracionForall',numeracionForall,' i',i);
                    numeracionForall++;

                  }
                  pdf.add(new Txt(numeracionForall+". "+element.question).fontSize(12).alignment('left').end);
                  pdf.add(pdf.ln(1));
                  element.answers.forEach( opc =>{
                    pdf.add(
                      new Ul([
                        new Item(
                          new Txt(opc.answer).fontSize(12).end
                        ).listType('circle').end
                      ]).end
                    )
                  });
                  pdf.add(pdf.ln(1));

                });
                // numeracionForall=0;
              }
            }

          }
          pdf.create().download(textoDescarga+this.informacion.nombreEmpresa+".pdf");
          Swal.close();
          this.translateSrv.use(this.claveidiomaAnterior);
        }
      });

    }
  }

  async generateNormaPDF(bandera){
    console.log("Bandera "+bandera);
    this.excelDialog();
    let secciones = this.translateSrv.instant('DESCARGAR_ENCUESTA.SECCIONES');
    let codigoProyecto = this.translateSrv.instant('DESCARGAR_ENCUESTA.CODIGOPROYECTO');
    let anioAplicacion = this.translateSrv.instant('DESCARGAR_ENCUESTA.ANIOAPLICACION');
    let mensaje = this.translateSrv.instant('DESCARGAR_ENCUESTA.MENSAJE');
    let aceptar = this.translateSrv.instant('DESCARGAR_ENCUESTA.ACEPTAR');
    let textoDescarga = this.translateSrv.instant('DESCARGAR_ENCUESTA.TEXTODESCARGA');
    let informacionAviso = this.translateSrv.instant('DESCARGAR_ENCUESTA.INFORMACIONYAVISO');
    let tipoEncuesta1 = this.translateSrv.instant('DESCARGAR_ENCUESTA.TIPOENC1');
    let tipoEncuesta2 = this.translateSrv.instant('DESCARGAR_ENCUESTA.TIPOENC2');

    let numeracion:number=1;
    let htmlToPdfmake = require("html-to-pdfmake");
    let informacionEncuesta:string;
    let descripcciones:string;
    this.odsService.getEncuestaNorma35(this.informacion.idEmpresa,this.informacion.idProducto,bandera).subscribe((respuesta:any) => {
      if(respuesta.success==true){
        const pdf = new PdfMakeWrapper();
        pdf.add(
          new Columns([
            new Txt(this.informacion.nombreEmpresa).bold().fontSize(30).end,
            new Txt(codigoProyecto+this.informacion.codigoDeProyecto+"\n"+
            anioAplicacion+this.informacion.fecha).bold().fontSize(12).alignment('right').end
          ]).end
        );

        //INFORMACION ENCUESTA
        pdf.add(pdf.ln(1));
        informacionEncuesta=htmlToPdfmake(respuesta.instrucciones);
        pdf.add(informacionEncuesta);
        pdf.add(pdf.ln(1));

        //SECCIONES NORMA35
        if(respuesta.array.length>0){
          pdf.add(new Txt(secciones).bold().fontSize(18).alignment('left').end);
          pdf.add(pdf.ln(1));

          respuesta.array.forEach(element => {
            descripcciones=htmlToPdfmake(element.descripcion);
            pdf.add(new Txt(descripcciones).bold().fontSize(12).alignment('left').end);
            pdf.add(pdf.ln(1));

            element.preguntas.forEach(preguntas => {
              pdf.add(new Txt(numeracion+". "+preguntas.pregunta).fontSize(12).alignment('left').end);
              pdf.add(pdf.ln(1));

              preguntas.respuestas.forEach(respuestas => {
                pdf.add(
                  new Ul([
                    new Item(
                      new Txt(respuestas.respuesta).fontSize(12).end
                    ).listType('circle').end
                  ]).end
                )
              });
              pdf.add(pdf.ln(1));
              numeracion=numeracion+1;
            });
            numeracion=1;
          });
        }
        let tipo:any;
        if(bandera==1){
          tipo=tipoEncuesta1;
        }else{
          tipo=tipoEncuesta2;
        }
        pdf.create().download(textoDescarga+this.informacion.nombreEmpresa+' '+tipo+".pdf");
      }
      Swal.close();
    }, error => {
      Swal.fire({
        title: mensaje,
        icon: 'warning',
        confirmButtonText: aceptar,
        confirmButtonColor: '#e40601'
      });
      // console.log("error", error);
    })
  }

}
